export const CURRENT_USER = "DSCA_CURRENT_USER";
export const ACCESS_TOKEN = "DSCA_ACCESS_TOKEN";
export const REFRESH_TOKEN = "DSCA_REFRESH_TOKEN";
export const IS_ADMIN = "DSCA_IS_ADMIN";
export const ROLE_ID = "DSCA_ROLE_ID";
